import { render, staticRenderFns } from "./PublicationTable.vue?vue&type=template&id=63fc6691"
import script from "./PublicationTable.vue?vue&type=script&lang=js"
export * from "./PublicationTable.vue?vue&type=script&lang=js"
import style0 from "./PublicationTable.vue?vue&type=style&index=0&id=63fc6691&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports